<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import SlaForm from './SlaForm.vue';

const props = defineProps({
  selectedResponse: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['close']);

const { t } = useI18n();
const store = useStore();

const onClose = () => emit('close');

const editSLA = async payload => {
  try {
    await store.dispatch('sla/update', {
      id: props.selectedResponse.id,
      ...payload,
    });
    useAlert(t('SLA.EDIT.API.SUCCESS_MESSAGE'));
    onClose();
  } catch (error) {
    useAlert(error.message || t('SLA.EDIT.API.ERROR_MESSAGE'));
  }
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('SLA.EDIT.TITLE')"
      :header-content="$t('SLA.EDIT.DESC')"
    />
    <SlaForm
      :selected-response="selectedResponse"
      :submit-label="$t('SLA.FORM.UPDATE')"
      @submit-sla="editSLA"
      @close="onClose"
    />
  </div>
</template>
